import React from 'react'
import PropTypes from 'prop-types'

import { YMInitializer } from 'react-yandex-metrika'

import { ThemeProvider } from 'react-bootstrap'

import { Helmet } from 'react-helmet'

const { instanceOf } = PropTypes
import { Cookies } from 'react-cookie'
import withSafeCookies from './withSafeCookies'

import Header from './../block/Header'
import Footer from './../block/Footer'

import TextPage from './../pages/TextPage'
import Main from './../pages/Main'
import Produkciya from './../pages/Produkciya'
import Portfolio from './../pages/Portfolio'
import Uslugi from './../pages/Uslugi'
import Kalkulator from './../pages/Kalkulator'
import Stati from './../pages/Stati'
import Ozavode from './../pages/Ozavode'
import Akcii from './../pages/Akcii'
import Partners from './../pages/Partners'
import Kontakti from './../pages/Kontakti'
import OknaDlyaBani from './../pages/OknaDlyaBani'
import PlastikOkna from './../pages/PlastikOkna'
import HSPortali from './../pages/HSPortali'
import Lestnici from './../pages/Lestnici'
import Nalichniki from './../pages/Nalichniki'
import MoskitnieSistemy from './../pages/MoskitnieSistemy'
import Ruchki from './../pages/Ruchki'
import Obsada from './../pages/Obsada'
import Vitrazi from './../pages/Vitrazi'
import Gotovie from './../pages/Gotovie'
import Ekonom from './../pages/Ekonom'
import DetskieZamki from './../pages/DetskieZamki'
import OknaIzDuba from './../pages/OknaIzDuba'
import OknaVKvartirah from './../pages/OknaVKvartirah'
import NashiOtzivi from './../pages/NashiOtzivi'
import Prices from './../pages/Prices'
import Restovraciya from './../pages/Restovraciya'
import Ustanovka from './../pages/Ustanovka'

import './config.scss'

class App extends React.Component {

  static propTypes = {
    cookies: instanceOf(Cookies).isRequired,
  }

  constructor(props) {
    super(props)
    const { cookies } = this.props

    this.state = {
      loading: props?.data.loaded == false || true,
      pages: {},
      data: props?.data || {},
      protocol: `https`,
      assets_path: `IOJKDfb_assets`
    }
  }

  renderPage() {
    const { data, protocol, assets_path } = this.state

    if( data.template == 1 ) return (
      <Main
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 2 ) return (
      <Produkciya
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 3 ) return (
      <Portfolio
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 5 ) return (
      <Uslugi
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 6 ) return (
      <Kalkulator
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 7 ) return (
      <Stati
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 8 ) return (
      <Ozavode
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 9 ) return (
      <Akcii
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 10 ) return (
      <Partners
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 11 ) return (
      <Kontakti
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 13 ) return (
      <OknaDlyaBani
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 14 ) return (
      <PlastikOkna
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 15 ) return (
      <HSPortali
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 16 ) return (
      <Lestnici
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 17 ) return (
      <Nalichniki
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 18 ) return (
      <MoskitnieSistemy
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 19 ) return (
      <Ruchki
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 20 ) return (
      <Obsada
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 21 ) return (
      <Vitrazi
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 22 ) return (
      <Gotovie
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 23 ) return (
      <Ekonom
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 24 ) return (
      <DetskieZamki
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 25 ) return (
      <OknaIzDuba
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 31 ) return (
      <OknaVKvartirah
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 34 ) return (
      <NashiOtzivi
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 35 ) return (
      <Prices
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 39 ) return (
      <Restovraciya
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    if( data.template == 40 ) return (
      <Ustanovka
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
    return (
      <TextPage
        data={data}
        protocol={protocol}
        assets_path={assets_path}
      />
    )
  }

  render() {

    const { data, protocol, assets_path } = this.state

    const scriptString = `
      <script>
        (function () { 
          var widget = document.createElement('script'); 
          widget.defer = true; 
          widget.dataset.pfId = 'f36dc5ba-3d90-4313-a181-f1ba93b67001'; 
          widget.src = 'https://widget.yourgood.app/script/widget.js?id=f36dc5ba-3d90-4313-a181-f1ba93b67001&now='+Date.now(); 
          document.head.appendChild(widget); 
        })()
      </script>
    `;

    return (
      <>
        <Helmet>
          <title>{data?.helmet.title || 'goodwin-nnov.ru'}</title>

          <base href={`${protocol}://${data?.helmet.host || 'goodwin-nnov.ru'}/`} />

          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta name="robots" content="all" />

          <meta name="description" content={data?.helmet.description || 'goodwin-nnov.ru'} />

          <meta property="og:type" content="website" />
          <meta property="og:title" content={data?.helmet.title || 'goodwin-nnov.ru'} />
          <meta property="og:description" content={data?.helmet.description || 'goodwin-nnov.ru'} />
          <meta property="og:image" content={`${protocol}://${data?.helmet.host || 'goodwin-nnov.ru'}/files/images/logo.svg`} />
          <meta property="og:url" content= {`${protocol}://${data?.helmet.host || 'goodwin-nnov.ru'}`} />

          <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
        </Helmet>
        <ThemeProvider
          breakpoints={['xxl', 'xl', 'lg', 'md', 'sm']}
          minBreakpoint="sm"
        >
          <div className='content_fw'>
            <Header
              logo={data?.logo}
              sitename={data?.sitename}
              slogan={data?.slogan}
              adres={data?.adres}
              phone={data?.phone}
              sitemail={data?.sitemail}
              vklink={data?.vklink}
              youlink={data?.youlink}
              rutubelink={data?.rutubelink}
              marshrut={data?.marshrut}
              assets_path={assets_path}
              menu={data?.menu || []}
            />
            <div className='content_fw_pagecontent'>
              {this.renderPage()}
            </div>
            <Footer
              logo={data?.logo}
              sitename={data?.sitename}
              slogan={data?.slogan}
              adres={data?.adres}
              phone={data?.phone}
              sitemail={data?.sitemail}
              vklink={data?.vklink}
              youlink={data?.youlink}
              rutubelink={data?.rutubelink}
              marshrut={data?.marshrut}
              assets_path={assets_path}
              menu={data?.menu || []}
              produkciya={data?.produkciya || []}
              portfolio={data?.portfolio || []}
              pconf_link={data?.pconf_link || ``}
            />
          </div>
        </ThemeProvider>
        <YMInitializer accounts={[44807914,35823060]} options={{webvisor: true}} version="2" />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (window.Image ? (new Image()) : document.createElement('img')).src = 
              'https://vk.com/rtrg?p=VK-RTRG-203786-dnRNx';
            `
          }}
        />
        <div dangerouslySetInnerHTML={{ __html: scriptString }} />
      </>
    )
  }
}

App.propTypes = {
  data: PropTypes.object,
  get: PropTypes.object
}

export default withSafeCookies(App)